import type { CreatePortfolioSchema } from '@labi-api-libs/schemas'
import { httpClient } from '@/services/http/httpClient'

type CreatePortfolioResponse = {
  id: string
  title: string
  description: string
  tennantId: string
  ownerId: string
}

export async function createPortfolio({
  title,
  description,
}: CreatePortfolioSchema): Promise<CreatePortfolioResponse> {
  const { data } = await httpClient.post<CreatePortfolioResponse>(
    '/projects/portfolios/',
    {
      title,
      description,
    },
  )

  return data
}
